import React, {useState, useEffect, Fragment} from "react";
import {Row, ModalFooter} from "reactstrap";
import {useDispatch, useSelector} from "react-redux";
import {toast} from "react-toastify";
import * as EmailValidator from "email-validator";
import {isEmpty} from "lodash";
import ProtectedContent, {usePermissionCheck} from "../protectedContent";
import ZeusButton from "../../components/Button";
import SelectCreator from "./components/SelectCreator";
import InputCreator from "./components/InputCreator";
import ToggleCreator from "./components/ToggleCreator";
import {
  sendAddUserModalData,
  sendEditUserModalData,
} from "../../redux/Actions/users.action";
import {requestGroupLabelValue} from "../../redux/Actions/group.action";
import {getUserProfile} from "../../redux/Selectors/users.selector";
import {getGroupLabelValue} from "../../redux/Selectors/group.selector";
import {useFetchUsers} from "../../views/Users/usersTable/useUserTableData";

const DEFAULT_FORM_DATA = {
  first_name: "",
  last_name: "",
  email: "",
  username: "",
  is_org_user: false,
  groups: [],
};

const AddUserForm = (props) => {
  const {data, onCancel} = props;
  const dispatch = useDispatch();
  const {refetch} = useFetchUsers();
  const [submitted, setSubmitted] = useState(false);
  const userProfile = useSelector(getUserProfile);
  const groupsList = useSelector(getGroupLabelValue);
  const [formData, setFormData] = useState(data || DEFAULT_FORM_DATA);
  const {
    id,
    first_name = "",
    last_name = "",
    email = "",
    username = "",
    is_org_user = false,
    groups = [],
  } = formData;

  const canViewGroups = usePermissionCheck(["view_group"]);

  useEffect(() => {
    if (canViewGroups) {
      dispatch(requestGroupLabelValue());
    }
  }, [canViewGroups, dispatch]);

  const onChangeHandler = (e) => {
    let updateObj = {...formData};
    updateObj = Object.assign({}, updateObj, {[e.target.name]: e.target.value});
    setFormData(updateObj);
  };

  const handleToggle = (name, value) => {
    let updateObj = {...formData};
    updateObj = Object.assign({}, updateObj, {[name]: value});
    setFormData(updateObj);
  };

  const onFormSubmit = () => {
    setSubmitted(true);
    if (!isEmpty(username) && !isEmpty(email)) {
      const callback = () => {
        onCancel();
        refetch();
      };
      if (id) {
        dispatch(sendEditUserModalData(formData, callback));
      } else {
        dispatch(sendAddUserModalData(formData, callback));
      }
    } else {
      toast.error("Please check required fields");
    }
  };

  return (
    <Fragment>
      <div>
        <div className="pl-lg-4">
          <Row>
            <InputCreator
              label={"First Name"}
              id="first_name"
              placeholder="John"
              name="first_name"
              data-cy="first_name"
              value={first_name}
              onChange={onChangeHandler}
              large
            />
            <InputCreator
              label={"Last Name"}
              id="first_name"
              placeholder="Doe"
              name="last_name"
              data-cy="last_name"
              value={last_name}
              onChange={onChangeHandler}
              large
            />
            <InputCreator
              label={"Username"}
              id="username"
              placeholder="john.doe"
              name="username"
              data-cy="username"
              value={username}
              onChange={onChangeHandler}
              large
              isRequired
              invalid={isEmpty(username) && submitted}
              disabled={id}
            />
            <InputCreator
              label={"Email"}
              id="email"
              placeholder="johndoe@example.com"
              name="email"
              data-cy="email"
              value={email}
              onChange={onChangeHandler}
              large
              isRequired
              invalid={(isEmpty(email) || !EmailValidator.validate(email)) && submitted}
            />
            <ProtectedContent perms={["view_group"]}>
              <SelectCreator
                label={"Groups"}
                id={"groups"}
                classNamePrefix={"groups"}
                name={"groups"}
                data-cy={"groups"}
                options={groupsList}
                isMulti
                isSearchable
                onChange={onChangeHandler}
                large
                value={groups}
              />
            </ProtectedContent>

            {(userProfile.is_org_user ||
              userProfile.is_owner ||
              userProfile.is_staff ||
              userProfile.is_superuser) && (
              <ToggleCreator
                label={"Organization User"}
                checked={is_org_user}
                onChange={() => handleToggle("is_org_user", !is_org_user)}
                large
              />
            )}
          </Row>
        </div>
      </div>
      <ModalFooter>
        <ZeusButton data-cy="submit-btn" onClick={() => onFormSubmit()}>
          SEND
        </ZeusButton>
        <ZeusButton data-cy="cancel-btn" onClick={onCancel} className="info-small">
          CANCEL
        </ZeusButton>
      </ModalFooter>
    </Fragment>
  );
};

export default AddUserForm;
